import BarChartIcon from '@material-ui/icons/BarChart';
import FaceIcon from '@material-ui/icons/Face';
import HomeIcon from '@material-ui/icons/Home';
import WidgetsIcon from '@material-ui/icons/Widgets';

const seedDrawerRoutes = [
  {
    id: 'first-section',
    routes: [
      {
        path: '/',
        labelId: 'seed.home.drawer',
        Icon: HomeIcon,
      },
      {
        path: '/crud',
        labelId: 'seed.crud.sample.drawer',
        Icon: FaceIcon,
      },
      {
        path: '/widgets',
        labelId: 'seed.widgets.drawer',
        Icon: WidgetsIcon,
        nested: true,
        routes: [
          {
            path: '/widgets/my-snackbar',
            labelId: 'seed.widgets.MySnackbar.drawer',
          },
          {
            path: '/widgets/my-linearprogress',
            labelId: 'seed.widgets.MyLinearProgress.drawer',
          },
        ],
      },
      {
        path: '/charts',
        labelId: 'seed.charts.drawer',
        Icon: BarChartIcon,
      },
    ],
  },
];

export default seedDrawerRoutes;
